
import {Component, Mixins} from 'vue-property-decorator';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import {CaseDictionaryDialogRequest, TableHeader} from '@/model/CommonModel';

@Component({
  mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin],
})
export default class CodeSearchDialogMixin extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
  protected errMsg: string = '';
  protected alertMsg: string = '';
  protected values: any[] = [];
  protected onSelect: (data: any) => void;
  protected onCancel: (keyword: string) => void;
  protected firstOpen: boolean = true;

  get getAlert() {
    return this.errMsg.length > 0 ? this.errMsg : this.alertMsg;
  }

  get getValues() {
    return this.values;
  }

  get isLoading() {
    return this.loading;
  }

  public getTableHeaderColumns(i18nPath: string, columnIds: string[]): TableHeader[] {
    return columnIds.map((columnId: string) => ({
      columnId,
      columnLabel: this.$t(`message.case.${i18nPath}.${columnId}`).toString(),
      visible: 'Y'
    }));
  }

  public show(request: CaseDictionaryDialogRequest<any>) {
    this.alertMsg = this.$t('message.case.dialog.alert').toString();
    this.errMsg = '';
    this.width = request.width ? request.width : this.DEFAULT_WIDTH;
    this.onSelect = request.onSelect;
    this.onCancel = request.onCancel;
    this.keyword = request.keyword;
    this.maxLength = request.maxLength;
    this.loading = false;
    this.visible = true;
    this.retrieve(1, 10);
  }

  public validateKeyword() {
    this.lastKeyword = this.keyword;
    this.keyword = this.keyword.trim();

    if (this.firstOpen && !this.keyword) {
      this.values = [];
      this.firstOpen = false;
      return false;
    }

    if (this.keyword?.length < 2) {
      this.errMsg = this.$t('message.case.dialog.directInputMinLength').toString();
      this.values = [];
      return false;
    }
    
    this.errMsg = '';
    this.alertMsg = this.$t('message.case.dialog.alert').toString();
    return true;
  }

  public onRowClick(data: any) {
    if (this.onSelect) {
      this.onSelect(data.row);
    }

    this.close();
  }

  public close() {
    if (this.onCancel) {
      this.onCancel(this.lastKeyword);
    }
    this.visible = false;
  }

  public afterClosed() {
    this.values = [];
    this.keyword = '';
    this.lastKeyword = '';
    this.loading = false;
  }
}
